<i18n>
{
  "en": {
    "title": "Planet & Society Barometer 2015 – 2017 Results",
    "description": "Since 2005, the Planet & Society Barometer has guided and measured Schneider Electric’s sustainable development. See how the company performed against sustainability goals including climate impact targets, circular economy, ethics, and health and equity.",
    "companyPerformance": {
      "section": "Company Performance",
      "title": "2015 &ndash; 2017 Planet &amp; Society Barometer",
      "PSBarometer": {
        "quote1": {
          "title": "Chief Sustainability Officer,",
          "company": "Schneider Electric",
          "p1": "We closed the 2015 &ndash; 2017 period with a record result for the barometer. We achieved 9.58/10, above our target of 9/10 &mdash; an unrivaled performance since the launch of the barometer in 2005."
        },
        "txt1": {
          "title": "Measuring our sustainable development",
          "p1": "Since 2005, the Planet &amp; Society barometer has guided and measured our sustainable development. Our performance is audited by a third party and progress is tracked and published quarterly at schneider-electric.com.",
          "cta": "See the full results"
        },
        "txt2": {
          "p1": "Now reimagined for 2018 &ndash; 2020 as the Schneider Sustainability Impact, it reflects our holistic view of sustainability and our promises to our partners, customers, and the world. It is the standard by which we measure ourselves and hold ourselves accountable.",
          "cta": "Learn more"
        },
        "vid1": {
          "title": "Planet & Society Barometer Performance",
          "desc": "Chris Leong, <br>Executive Vice President, Global Marketing, Schneider Electric"
        }
      }
    }
  },
  "fr": {
    "title": "Baromètre Planète & Société 2015 - 2017",
    "description": "Since 2005, the Planet & Society Barometer has guided and measured Schneider Electric’s sustainable development. See how the company performed against sustainability goals including climate impact targets, circular economy, ethics, and health and equity.",
    "companyPerformance": {
      "section": "Performance de l'Entreprise",
      "title": "Baromètre Planète & Société 2015 - 2017",
      "PSBarometer": {
        "quote1": {
          "title": "Directeur Développement Durable,",
          "company": "Schneider Electric",
          "p1": "Les résultats du baromètre Planète & Société, pour la période 2015 -2017, ont été exceptionnels. Nous avons obtenu la note de 9,58/10 dépassant ainsi notre objectif de 9/10, un résultat sans précédent depuis la création du baromètre en 2005."
        },
        "txt1": {
          "title": "Le tableau de bord de notre performance en développement durable",
          "p1": "Depuis 2005, le baromètre Planète & Société présente les objectifs de développement durable du Groupe et donne la mesure globale de nos progrès. Notre performance est auditée chaque année par Ernst & Young et Associés et nos résultats sont publiés chaque trimestre sur schneider-electric.com.",
          "cta": "Retrouvez les résultats du baromètre"
        },
        "txt2": {
          "p1": "Notre nouveau baromètre pour 2018 - 2020 porte le nom de Schneider Sustainability Impact. Il symbolise notre vision holistique du développement durable et notre ambition  vis-à-vis de nos partenaires, de nos clients et de la planète. C'est notre plan de progrès qui nous permet de nous mesurer et de rendre des comptes.",
          "cta": "En savoir plus"
        },
        "vid1": {
          "title": "Performance du baromètre Planète & Société",
          "desc": "Chris Leong, <br>Directrice générale Marketing"
        }
      }
    }
  }
}
</i18n>
<template>
  <div id="">
    <Hero :loResSrc="require('../../assets/img/company-performance/company-performance-barometer-hero-lowres.jpg')" :hiResSrc="require('../../assets/img/company-performance/company-performance-barometer-hero.jpg')" chapter="06" :section="$t('companyPerformance.section')" :title="$t('companyPerformance.title')" :grayBG="true" />

    <section class="m-b-120 m-t-120">
      <YouTubeVideo videoId="8qjEE87xIFU" :title="$t('companyPerformance.PSBarometer.vid1.title')" :description="$t('companyPerformance.PSBarometer.vid1.desc')" :preview="require('@/assets/img/thumbnails/SSDHighlightVideo_ChrisLeong_Still.jpg')" />
    </section>

    <section class="m-t-120">
      <Quote name="Gilles Vermot Desroches" :title="$t('companyPerformance.PSBarometer.quote1.title')" :company="$t('companyPerformance.PSBarometer.quote1.company')" :photo="require('@/assets/img/looking-ahead/Gilles_Vermot_Desroches_2017.jpg')">
        <div v-html="$t('companyPerformance.PSBarometer.quote1.p1')"></div>
      </Quote>
    </section>

    <section class="l-bg-white l-section-pad m-b-120">
      <Txt class="m-b-45">
        <h2 id="measuringsustainabledevelopment" v-html="$t('companyPerformance.PSBarometer.txt1.title')"></h2>
        <p v-html="$t('companyPerformance.PSBarometer.txt1.p1')"></p>
        <CTA href="/static/PSBarometer-Q42017_results.pdf" :buttonText="$t('companyPerformance.PSBarometer.txt1.cta')" target="_blank"/>
      </Txt>
      <Txt>
        <p v-html="$t('companyPerformance.PSBarometer.txt2.p1')"></p>
        <router-link class="cta-button-route" :to="{ name: 'Introduction_WorkIndex'}" v-html="$t('companyPerformance.PSBarometer.txt2.cta')"></router-link>
      </Txt>
    </section>

   <div class="l-content">
      <FooterNav
        nextRoute="CompanyPerformance_Leadership"
        prevRoute="CompanyPerformance_YearInReview" />
    </div>

  </div>
</template>

<script>
import FooterNav from '@/components/FooterNav'
import Hero from '@/components/Hero'
import Quote from '@/components/Quote'
import Statement from '@/components/Statement'
import FourCols from '@/components/FourCols'
import FourColsItem from '@/components/FourColsItem'
import CTA from '@/components/CTA'
import Txt from '@/components/Txt'
import References from '@/components/References'
import Reference from '@/components/Reference'
import YouTubeVideo from '@/components/YouTubeVideo'
import CTARoute from '@/components/CTARoute'

export default {
  name: 'CompanyPerformance_20152017PlanetSocietyBarometer',
  metaInfo () {
    return {
      title: this.$t('title'),
      meta: [
        { name: 'description', content: this.$t('description') }
      ]
    }
  },
  mounted () {
    if (window.location.hash.substr(1).length > 0) {
      this.$nextTick(function () {
        document.getElementById(window.location.hash.substr(1)).scrollIntoView()
      })
    }
  },
  components: {
    FooterNav,
    Hero,
    Quote,
    Statement,
    FourCols,
    FourColsItem,
    CTA,
    Txt,
    References,
    Reference,
    YouTubeVideo,
    CTARoute
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/company-performance/2015-2017-planet-society-barometer.vue